<template>
  <LayoutDefault>
    <Error403404 errorType="404" />
  </LayoutDefault>
</template>

<script>
import Error403404 from '@/components/error-403-404.vue';
import LayoutDefault from '@/layouts/default.vue';

export default {
  components: {
    LayoutDefault,
    Error403404,
  },
};
</script>
